import React from "react";

function LandingText() {
  return (
    <div className="landing--right__container">
      <div className="landing--right--text__container">
        <h3>Get smarter about what matters to you</h3>
        <p>Read unlimited stories without any subscription</p>
      </div>
    </div>
  );
}

export default LandingText;
